import lazyWithRetry from '@shared/lib/lazyWithRetry';

import AuthLayout from '@components/AuthLayout/ui/AuthLayout.tsx';
import SignUpFormProvider from '@providers/SignUpFormProvider/ui/SignUpFormProvider.tsx';
import Loadable from '@components/Loadable/Loadable.tsx';
import SignInPage from '@pages/SignIn/SignIn.tsx';
import SignUpForm from '@features/SignUp/SignUpForm/SignUpForm';
import IndividualSignUpForm from '@features/SignUp/IndividualSignUpForm/IndividualSignUpForm';
import SignUpVerifyUserForm from '@features/SignUp/SignUpVerifyUserForm/SignUpVerifyUserForm';
import BusinessSignUpForm from '@features/SignUp/BusinessSignUpForm/BusinessSignUpForm';
import SignUpVerifyUserOTPForm from '@features/SignUp/SignUpVerifyUserOTPForm/SignUpVerifyUserOTPForm';

const ForgotPasswordPage = Loadable(
  lazyWithRetry(() => import('@pages/ForgotPasswordPage/ForgotPasswordPage'))
);
const ResetPasswordPage = Loadable(
  lazyWithRetry(() => import('@pages/ResetPasswordPage/ResetPasswordPage'))
);
const ActivateUserPage = Loadable(
  lazyWithRetry(() => import('@pages/ActivateUser/ActivateUser'))
);

const AuthenticationRoutes = {
  // Wrap the entire auth route tree so OTP/email values stored during sign-in
  // are still available on verify routes after navigation.
  element: (
    <SignUpFormProvider>
      <AuthLayout />
    </SignUpFormProvider>
  ),
  children: [
    {
      path: 'sign-in',
      element: <SignInPage />,
    },
    {
      path: 'sign-up',
      element: <SignUpForm />,
    },
    {
      path: 'verify-user',
      element: <SignUpVerifyUserForm />,
    },
    {
      path: 'verify-user-otp',
      element: <SignUpVerifyUserOTPForm />,
    },
    {
      path: 'individual-sign-up',
      element: <IndividualSignUpForm />,
    },
    {
      path: 'business-sign-up',
      element: <BusinessSignUpForm />,
    },
    { path: 'forgot-password', element: <ForgotPasswordPage /> },
    { path: 'reset-password/:uid/:token', element: <ResetPasswordPage /> },
    { path: 'activate-account', element: <ActivateUserPage /> },
  ],
};

export default AuthenticationRoutes;
